import {MappedComponentProperties} from "@adobe/aem-react-editable-components";
import React from "react";
import extractModelId from "../../utils/extract-model-id";
import { Banner, BannerData } from "../../ui.lib/components/shared/banner";

 const BannerComponent = (props: MappedComponentProperties & {"data": any}) => {
  console.log('CtaComponent---data', props);
  const {data} = props;
  const CMS_BANNER_DATA: BannerData = {
    id: data?.id,
    backgroundColor: data?.backgroundColor,
    reduceTopSpacing: data?.reduceTopSpacing,
    reduceBottomSpacing: data?.reduceBottomSpacing,
    isBannerEnable: data?.isBannerEnable,
    descriptionHTML: {
      __html: data?.descriptionHTML,
    }
  }
   return <div id={extractModelId(props.cqPath)}>
      <Banner data={CMS_BANNER_DATA} />
   </div>
 };
 
 export default BannerComponent;